var chunkToChildrenMap = {
	"5385": [
		7823,
		2506,
		7747,
		1869,
		8812,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};